import React, { FunctionComponent } from "react"
import { Tooltip, makeStyles, Theme, TooltipProps } from "@material-ui/core"

/** Scoped @material-ui/core stylesheet */
const useClasses = makeStyles<Theme>(theme => ({
  tooltip: {
    fontSize: 12,
  },
}))

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  target: {
    color: theme.palette.secondary.main,
    marginLeft: theme.spacing(0.5),
    fontSize: 12,
  },
}))

export const FieldHelpTooltip: FunctionComponent<Omit<
  TooltipProps,
  "children"
>> = ({ title, ...props }) => {
  /** Get scoped CSS classes */
  const classes = useClasses()
  const styles = useStyles()

  return title ? (
    <Tooltip title={title} arrow classes={classes} interactive {...props}>
      <span className={styles.target}>(What is this?)</span>
    </Tooltip>
  ) : null
}
